var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100.77 29.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #00caff;\n      }\n\n      .cls-3 {\n        fill: #f4324a;\n      }\n\n      .cls-4 {\n        fill: #02ed76;\n      }\n\n      .cls-5 {\n        fill: #ffbd00;\n      }\n\n      .cls-6 {\n        fill: #ffc100;\n      }\n\n      .cls-7 {\n        fill: #ffd100;\n      }\n\n      .cls-8 {\n        fill: #e02553;\n      }\n\n      .cls-9 {\n        fill: #00a3ff;\n      }\n\n      .cls-10 {\n        fill: #ffd800;\n      }\n\n      .cls-11 {\n        fill: #00f076;\n      }\n\n      .cls-12 {\n        opacity: .25;\n      }\n\n      .cls-12, .cls-13, .cls-14 {\n        isolation: isolate;\n      }\n\n      .cls-13 {\n        opacity: .12;\n      }\n\n      .cls-15 {\n        fill: #00d5ff;\n      }\n\n      .cls-14 {\n        opacity: .2;\n      }\n\n      .cls-16 {\n        fill: #09e375;\n      }\n\n      .cls-17 {\n        fill: #fc0;\n      }\n\n      .cls-18 {\n        fill: #00baff;\n      }\n\n      .cls-19 {\n        fill: #ffcf00;\n      }\n\n      .cls-20 {\n        fill: #00a6ff;\n      }\n\n      .cls-21 {\n        fill: #e32752;\n      }\n\n      .cls-22 {\n        fill: #ffcb00;\n      }\n\n      .cls-23 {\n        fill: #12d474;\n      }\n\n      .cls-24 {\n        fill: #00c2ff;\n      }\n\n      .cls-25 {\n        fill: #f53349;\n      }\n\n      .cls-26 {\n        fill: #dd2355;\n      }\n\n      .cls-27 {\n        fill: #07e675;\n      }\n\n      .cls-28 {\n        fill: #00e2ff;\n      }\n\n      .cls-29 {\n        fill: #0ed974;\n      }\n\n      .cls-30 {\n        fill: #ffd400;\n      }\n\n      .cls-31 {\n        fill: #eb2c4e;\n      }\n\n      .cls-32 {\n        fill: #0af;\n      }\n\n      .cls-33 {\n        fill: #13d274;\n      }\n\n      .cls-34 {\n        fill: #ffde00;\n      }\n\n      .cls-35 {\n        fill: #00e3ff;\n      }\n\n      .cls-36 {\n        fill: #00bdff;\n      }\n\n      .cls-37 {\n        fill: #e92b4f;\n      }\n\n      .cls-38 {\n        fill: #00c4ff;\n      }\n\n      .cls-39 {\n        fill: #f83548;\n      }\n\n      .cls-40 {\n        fill: #ffd900;\n      }\n\n      .cls-41 {\n        fill: #00bcff;\n      }\n\n      .cls-42 {\n        fill: #0cf;\n      }\n\n      .cls-43 {\n        fill: #00c5ff;\n      }\n\n      .cls-44 {\n        fill: #05e975;\n      }\n\n      .cls-45 {\n        fill: #e72950;\n      }\n\n      .cls-46 {\n        fill: #07e575;\n      }\n\n      .cls-47 {\n        fill: #00c3ff;\n      }\n\n      .cls-48 {\n        fill: #00d4ff;\n      }\n\n      .cls-49 {\n        fill: #11d574;\n      }\n\n      .cls-50 {\n        fill: #ffd000;\n      }\n\n      .cls-51 {\n        fill: #ffbe00;\n      }\n\n      .cls-52 {\n        fill: #00a9ff;\n      }\n\n      .cls-53 {\n        fill: #03ec76;\n      }\n\n      .cls-54 {\n        fill: #10d674;\n      }\n\n      .cls-55 {\n        fill: #05e875;\n      }\n\n      .cls-56 {\n        fill: #e52851;\n      }\n\n      .cls-57 {\n        fill: #00a8ff;\n      }\n\n      .cls-58 {\n        fill: #00d9ff;\n      }\n\n      .cls-59 {\n        fill: #0ae175;\n      }\n\n      .cls-60 {\n        fill: #de2454;\n      }\n\n      .cls-61 {\n        fill: #fd3945;\n      }\n\n      .cls-62 {\n        fill: #00b6ff;\n      }\n\n      .cls-63 {\n        fill: #ffc600;\n      }\n\n      .cls-64 {\n        fill: #e62951;\n      }\n\n      .cls-65 {\n        fill: #00a0ff;\n      }\n\n      .cls-66 {\n        fill: #0eda74;\n      }\n\n      .cls-67 {\n        fill: #00b0ff;\n      }\n\n      .cls-68 {\n        fill: #00b1ff;\n      }\n\n      .cls-69 {\n        fill: #00beff;\n      }\n\n      .cls-70 {\n        fill: #00d6ff;\n      }\n\n      .cls-71 {\n        fill: #ea2b4f;\n      }\n\n      .cls-72 {\n        fill: #ffc900;\n      }\n\n      .cls-73 {\n        fill: #fb0;\n      }\n\n      .cls-74 {\n        fill: #a6a6a6;\n      }\n\n      .cls-75 {\n        fill: #00cbff;\n      }\n\n      .cls-76 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-77 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-78 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-79 {\n        fill: #f1304b;\n      }\n\n      .cls-80 {\n        fill: #ffdb00;\n      }\n\n      .cls-81 {\n        fill: #ffd200;\n      }\n\n      .cls-82 {\n        fill: #00d7ff;\n      }\n\n      .cls-83 {\n        fill: #04ea75;\n      }\n\n      .cls-84 {\n        fill: #ffd300;\n      }\n\n      .cls-85 {\n        fill: #00b3ff;\n      }\n\n      .cls-86 {\n        fill: #00ceff;\n      }\n\n      .cls-87 {\n        fill: #01ef76;\n      }\n\n      .cls-88 {\n        fill: #0be075;\n      }\n\n      .cls-89 {\n        fill: #e42752;\n      }\n\n      .cls-90 {\n        fill: #ffc300;\n      }\n\n      .cls-91 {\n        fill: #fff;\n      }\n\n      .cls-92 {\n        fill: #ffc000;\n      }\n\n      .cls-93 {\n        fill: #10d774;\n      }\n\n      .cls-94 {\n        fill: #00bfff;\n      }\n\n      .cls-95 {\n        fill: #00cdff;\n      }\n\n      .cls-96 {\n        fill: #02ee76;\n      }\n\n      .cls-97 {\n        fill: #00a7ff;\n      }\n\n      .cls-98 {\n        fill: #f0304c;\n      }\n\n      .cls-99 {\n        fill: #06e775;\n      }\n\n      .cls-100 {\n        fill: #ffc800;\n      }\n\n      .cls-101 {\n        fill: #df2454;\n      }\n\n      .cls-102 {\n        fill: #0bf;\n      }\n\n      .cls-103 {\n        fill: #00cfff;\n      }\n\n      .cls-104 {\n        fill: #00aeff;\n      }\n\n      .cls-105 {\n        fill: #e82a50;\n      }\n\n      .cls-106 {\n        fill: #ffc500;\n      }\n\n      .cls-107 {\n        fill: #0ddc75;\n      }\n\n      .cls-108 {\n        fill: #00abff;\n      }\n\n      .cls-109 {\n        fill: #fe3945;\n      }\n\n      .cls-110 {\n        fill: #0ddd75;\n      }\n\n      .cls-111 {\n        fill: #f73448;\n      }\n\n      .cls-112 {\n        fill: #00b9ff;\n      }\n\n      .cls-113 {\n        fill: #f63449;\n      }\n\n      .cls-114 {\n        fill: #12d374;\n      }\n\n      .cls-115 {\n        fill: #0cde75;\n      }\n\n      .cls-116 {\n        fill: #ee2e4d;\n      }\n\n      .cls-117 {\n        fill: #ffda00;\n      }\n\n      .cls-118 {\n        fill: #ffd500;\n      }\n\n      .cls-119 {\n        fill: #ffbc00;\n      }\n\n      .cls-120 {\n        fill: #00d3ff;\n      }\n\n      .cls-121 {\n        fill: #00dfff;\n      }\n\n      .cls-122 {\n        fill: #00d0ff;\n      }\n\n      .cls-123 {\n        fill: #00c0ff;\n      }\n\n      .cls-124 {\n        fill: #00c1ff;\n      }\n\n      .cls-125 {\n        fill: #00b2ff;\n      }\n\n      .cls-126 {\n        fill: #fa3747;\n      }\n\n      .cls-127 {\n        fill: #fd0;\n      }\n\n      .cls-128 {\n        fill: #00dbff;\n      }\n\n      .cls-129 {\n        fill: #00d1ff;\n      }\n\n      .cls-130 {\n        fill: #00c9ff;\n      }\n\n      .cls-131 {\n        fill: #f2314b;\n      }\n\n      .cls-132 {\n        fill: #00b8ff;\n      }\n\n      .cls-133 {\n        fill: #0bdf75;\n      }\n\n      .cls-134 {\n        fill: #00deff;\n      }\n\n      .cls-135 {\n        fill: #ff3a44;\n      }\n\n      .cls-136 {\n        fill: #ffd600;\n      }\n\n      .cls-137 {\n        fill: #ffcd00;\n      }\n\n      .cls-138 {\n        fill: #00acff;\n      }\n\n      .cls-139 {\n        fill: #15cf74;\n      }\n\n      .cls-140 {\n        fill: #00dcff;\n      }\n\n      .cls-141 {\n        fill: #09e275;\n      }\n\n      .cls-142 {\n        fill: #00a4ff;\n      }\n\n      .cls-143 {\n        fill: #ed2d4d;\n      }\n\n      .cls-144 {\n        fill: #08e475;\n      }\n\n      .cls-145 {\n        fill: #ffbf00;\n      }\n\n      .cls-146 {\n        fill: gold;\n      }\n\n      .cls-147 {\n        fill: #00b4ff;\n      }\n\n      .cls-148 {\n        fill: #f93647;\n      }\n\n      .cls-149 {\n        fill: #ffca00;\n      }\n\n      .cls-150 {\n        fill: #e22653;\n      }\n\n      .cls-151 {\n        fill: #ffc400;\n      }\n\n      .cls-152 {\n        fill: #ffc700;\n      }\n\n      .cls-153 {\n        fill: #ec2d4e;\n      }\n\n      .cls-154 {\n        fill: #fc3846;\n      }\n\n      .cls-155 {\n        fill: #14d074;\n      }\n\n      .cls-156 {\n        fill: #00e0ff;\n      }\n\n      .cls-157 {\n        fill: #00c7ff;\n      }\n\n      .cls-158 {\n        fill: #00a2ff;\n      }\n\n      .cls-159 {\n        fill: #ef2f4c;\n      }\n\n      .cls-160 {\n        fill: #f3324a;\n      }\n\n      .cls-161 {\n        fill: #0df;\n      }\n\n      .cls-162 {\n        fill: #00daff;\n      }\n\n      .cls-163 {\n        fill: #00b7ff;\n      }\n\n      .cls-164 {\n        fill: #ffc200;\n      }\n\n      .cls-165 {\n        fill: #00c6ff;\n      }\n\n      .cls-166 {\n        fill: #00a1ff;\n      }\n\n      .cls-167 {\n        fill: #00a5ff;\n      }\n\n      .cls-168 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-169 {\n        fill: #00b5ff;\n      }\n\n      .cls-170 {\n        fill: #ffdf00;\n      }\n\n      .cls-171 {\n        fill: #ffdc00;\n      }\n\n      .cls-172 {\n        fill: #fb3746;\n      }\n\n      .cls-173 {\n        fill: #00d2ff;\n      }\n\n      .cls-174 {\n        fill: #14d174;\n      }\n\n      .cls-175 {\n        fill: #0fd874;\n      }\n\n      .cls-176 {\n        fill: #00adff;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.76,5.6c-.22.22-.3.6-.3,1.04v16.5c0,.45.15.82.37,1.04l.07.07,9.26-9.26v-.15L7.76,5.6Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.15,18.14l-3.06-3.06v-.22l3.06-3.06.07.07,3.66,2.09c1.04.6,1.04,1.57,0,2.16l-3.73,2.02Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.23,18.06l-3.13-3.13-9.33,9.33c.37.37.9.37,1.57.07l10.9-6.27"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.23,11.79l-10.9-6.2c-.67-.37-1.19-.3-1.57.07l9.33,9.26,3.13-3.13h0Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.04,29.86H3.73c-2.09,0-3.73-1.64-3.73-3.73V3.73C0,1.64,1.64,0,3.73,0h93.3c2.09,0,3.73,1.64,3.73,3.73v22.39c0,2.09-1.64,3.73-3.73,3.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M97.04.6c1.72,0,3.13,1.42,3.13,3.13v22.39c0,1.72-1.42,3.13-3.13,3.13H3.73c-1.72,0-3.13-1.42-3.13-3.13V3.73C.6,2.02,2.02.6,3.73.6h93.3M97.04,0H3.73C1.64,0,0,1.72,0,3.73v22.39c0,2.09,1.64,3.73,3.73,3.73h93.3c2.09,0,3.73-1.64,3.73-3.73V3.73c0-2.02-1.64-3.73-3.73-3.73Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-91",
    points: "39.34 5.82 40.61 5.82 40.61 9.78 41.35 9.78 41.35 5.82 42.62 5.82 42.62 5.15 39.34 5.15 39.34 5.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M33.14,7.99h1.64c-.02.29-.13.55-.35.77-.36.36-.71.5-1.22.5-.45,0-.82-.24-1.15-.51-.33-.26-.49-.67-.49-1.21s.17-.95.49-1.21h.01c.25-.33.66-.51,1.14-.51.52,0,.86.15,1.14.49l.05.07.48-.48-.03-.05c-.17-.26-.44-.42-.7-.55-.31-.15-.62-.23-.93-.23-.68,0-1.22.22-1.69.69-.47.47-.69,1.01-.69,1.69s.22,1.22.69,1.69,1.01.69,1.69.69,1.22-.22,1.69-.69c.36-.36.54-.88.54-1.55v-.37h-2.31v.75Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 44.64,
    y: 5.15,
    width: 0.75,
    height: 4.63
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-91",
    points: "36.13 9.78 38.89 9.78 38.89 9.03 36.87 9.03 36.87 7.76 38.74 7.76 38.74 7.09 36.87 7.09 36.87 5.82 38.89 5.82 38.89 5.15 36.13 5.15 36.13 9.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-91",
    points: "59.19 5.15 59.19 8.47 57.17 5.19 57.14 5.15 56.36 5.15 56.36 9.78 57.03 9.78 57.03 6.3 59.23 9.78 59.94 9.78 59.94 5.15 59.19 5.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-91",
    points: "45.91 5.82 47.17 5.82 47.17 9.78 47.85 9.78 47.85 5.82 49.11 5.82 49.11 5.15 45.91 5.15 45.91 5.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M53.29,5.08c-.68,0-1.22.22-1.69.69-.47.47-.69,1.01-.69,1.69s.22,1.22.69,1.69,1.01.69,1.69.69,1.22-.22,1.69-.69.69-1.01.69-1.69-.22-1.22-.69-1.69c-.47-.47-1.01-.69-1.69-.69ZM54.94,7.46c0,.45-.18.9-.51,1.22-.26.32-.66.49-1.14.49-.4,0-.83-.19-1.14-.5h0c-.33-.27-.49-.68-.49-1.22,0-.45.18-.9.51-1.22.25-.32.66-.49,1.14-.49.4,0,.83.19,1.15.51.33.26.49.67.49,1.21Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M50.83,16.27c-1.79,0-3.21,1.34-3.21,3.21s1.42,3.21,3.21,3.21,3.21-1.34,3.21-3.21-1.42-3.21-3.21-3.21ZM50.83,21.35c-.97,0-1.79-.82-1.79-1.94s.82-1.94,1.79-1.94,1.79.75,1.79,1.94c0,1.12-.82,1.94-1.79,1.94ZM43.89,16.27c-1.79,0-3.21,1.34-3.21,3.21s1.42,3.21,3.21,3.21,3.21-1.34,3.21-3.21-1.42-3.21-3.21-3.21ZM43.89,21.35c-.97,0-1.79-.82-1.79-1.94s.82-1.94,1.79-1.94,1.79.75,1.79,1.94c0,1.12-.82,1.94-1.79,1.94ZM35.6,17.24v1.34h3.21c-.07.75-.37,1.34-.75,1.72-.45.45-1.19.97-2.46.97-2.02,0-3.51-1.57-3.51-3.58s1.57-3.58,3.51-3.58c1.04,0,1.87.45,2.46.97l.97-.97c-.82-.75-1.87-1.34-3.36-1.34-2.69,0-5,2.24-5,4.93s2.31,4.93,5,4.93c1.49,0,2.54-.45,3.43-1.42.9-.9,1.19-2.16,1.19-3.13,0-.3,0-.6-.07-.82h-4.63ZM69.49,18.29c-.3-.75-1.04-2.02-2.69-2.02s-2.99,1.27-2.99,3.21c0,1.79,1.34,3.21,3.13,3.21,1.42,0,2.31-.9,2.61-1.42l-1.04-.75c-.37.52-.82.9-1.57.9s-1.19-.3-1.57-.97l4.25-1.79-.15-.37h0ZM65.16,19.33c0-1.19.97-1.87,1.64-1.87.52,0,1.04.3,1.19.67l-2.84,1.19h0ZM61.65,22.39h1.42v-9.33h-1.42v9.33ZM59.42,16.94c-.37-.37-.97-.75-1.72-.75-1.57,0-3.06,1.42-3.06,3.21s1.42,3.13,3.06,3.13c.75,0,1.34-.37,1.64-.75h.07v.45c0,1.19-.67,1.87-1.72,1.87-.82,0-1.42-.6-1.57-1.12l-1.19.52c.37.82,1.27,1.87,2.84,1.87s2.99-.97,2.99-3.28v-5.67h-1.34v.52h0ZM57.77,21.35c-.97,0-1.79-.82-1.79-1.94s.82-1.94,1.79-1.94,1.72.82,1.72,1.94-.75,1.94-1.72,1.94ZM75.99,13.06h-3.36v9.33h1.42v-3.51h1.94c1.57,0,3.06-1.12,3.06-2.91s-1.49-2.91-3.06-2.91ZM76.06,17.54h-2.02v-3.21h2.02c1.04,0,1.64.9,1.64,1.57-.07.82-.67,1.64-1.64,1.64h0ZM84.64,16.2c-1.04,0-2.09.45-2.46,1.42l1.27.52c.3-.52.75-.67,1.27-.67.75,0,1.42.45,1.49,1.19v.07c-.22-.15-.82-.37-1.42-.37-1.34,0-2.69.75-2.69,2.09,0,1.27,1.12,2.09,2.31,2.09.97,0,1.42-.45,1.79-.9h.07v.75h1.34v-3.58c-.15-1.64-1.42-2.61-2.99-2.61h0ZM84.5,21.35c-.45,0-1.12-.22-1.12-.82,0-.75.82-.97,1.49-.97.6,0,.9.15,1.27.3-.15.9-.9,1.49-1.64,1.49ZM92.33,16.42l-1.57,4.03h-.07l-1.64-4.03h-1.49l2.46,5.67-1.42,3.13h1.42l3.81-8.81h-1.49ZM79.79,22.39h1.42v-9.33h-1.42v9.33Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-168"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-65",
    points: "17.17 7.4 15.37 5.6 17.17 5.6 17.17 7.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-65",
    points: "17.17 7.48 15.28 5.6 15.37 5.6 17.17 7.4 17.17 7.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "17.17 7.57 15.19 5.6 15.28 5.6 17.17 7.48 17.17 7.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "17.17 7.79 14.98 5.6 15.19 5.6 17.17 7.57 17.17 7.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-158",
    points: "17.17 8.01 14.76 5.6 14.98 5.6 17.17 7.79 17.17 8.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "17.17 8.23 14.54 5.6 14.76 5.6 17.17 8.01 17.17 8.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-142",
    points: "17.17 8.45 14.32 5.6 14.54 5.6 17.17 8.23 17.17 8.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "17.17 8.67 14.1 5.6 14.32 5.6 17.17 8.45 17.17 8.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "17.17 8.88 13.88 5.6 14.1 5.6 17.17 8.67 17.17 8.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-97",
    points: "17.17 9.1 13.66 5.6 13.88 5.6 17.17 8.88 17.17 9.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-57",
    points: "17.17 9.32 13.45 5.6 13.66 5.6 17.17 9.1 17.17 9.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "17.17 9.54 13.23 5.6 13.45 5.6 17.17 9.32 17.17 9.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "17.17 9.76 13.01 5.6 13.23 5.6 17.17 9.54 17.17 9.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-108",
    points: "17.17 9.98 12.79 5.6 13.01 5.6 17.17 9.76 17.17 9.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-138",
    points: "17.17 10.2 12.57 5.6 12.79 5.6 17.17 9.98 17.17 10.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "17.17 10.41 12.35 5.6 12.57 5.6 17.17 10.2 17.17 10.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-104",
    points: "17.17 10.63 12.13 5.6 12.35 5.6 17.17 10.41 17.17 10.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "17.17 10.85 11.92 5.6 12.13 5.6 17.17 10.63 17.17 10.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "17.17 11.07 11.7 5.6 11.92 5.6 17.17 10.85 17.17 11.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-125",
    points: "17.17 11.29 11.48 5.6 11.7 5.6 17.17 11.07 17.17 11.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "17.17 11.51 11.26 5.6 11.48 5.6 17.17 11.29 17.17 11.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-147",
    points: "17.17 11.73 11.04 5.6 11.26 5.6 17.17 11.51 17.17 11.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-169",
    points: "17.17 11.94 10.82 5.6 11.04 5.6 17.17 11.73 17.17 11.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "17.17 12.16 10.6 5.6 10.82 5.6 17.17 11.94 17.17 12.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-163",
    points: "17.17 12.38 10.39 5.6 10.6 5.6 17.17 12.16 17.17 12.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-132",
    points: "17.17 12.6 10.17 5.6 10.39 5.6 17.17 12.38 17.17 12.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-112",
    points: "17.17 12.82 9.95 5.6 10.17 5.6 17.17 12.6 17.17 12.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "17.17 13.04 9.73 5.6 9.95 5.6 17.17 12.82 17.17 13.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-102",
    points: "17.17 13.26 9.51 5.6 9.73 5.6 17.17 13.04 17.17 13.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "17.17 13.47 9.29 5.6 9.51 5.6 17.17 13.26 17.17 13.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "17.17 13.69 9.07 5.6 9.29 5.6 17.17 13.47 17.17 13.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "17.17 13.91 8.86 5.6 9.07 5.6 17.17 13.69 17.17 13.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "17.17 14.23 8.54 5.6 8.86 5.6 17.17 13.91 17.17 14.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-94",
    points: "17.17 14.54 8.22 5.6 8.54 5.6 17.17 14.23 17.17 14.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-123",
    points: "17.17 14.86 7.91 5.6 8.22 5.6 17.17 14.54 17.17 14.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "17.17 15.17 7.59 5.6 7.91 5.6 17.17 14.86 17.17 15.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "17.17 15.49 7.46 5.79 7.46 5.6 7.59 5.6 17.17 15.17 17.17 15.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "17.17 15.81 7.46 6.1 7.46 5.79 17.17 15.49 17.17 15.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "17.17 16.12 7.46 6.42 7.46 6.1 17.17 15.81 17.17 16.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "17.17 16.44 7.46 6.73 7.46 6.42 17.17 16.12 17.17 16.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-165",
    points: "17.17 16.75 7.46 7.05 7.46 6.73 17.17 16.44 17.17 16.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-157",
    points: "17.17 17.07 7.46 7.36 7.46 7.05 17.17 16.75 17.17 17.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "17.17 17.11 17.03 17.25 7.46 7.68 7.46 7.36 17.17 17.07 17.17 17.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "17.03 17.25 16.88 17.41 7.46 8 7.46 7.68 17.03 17.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "16.88 17.41 16.72 17.57 7.46 8.31 7.46 8 16.88 17.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "16.72 17.57 16.56 17.72 7.46 8.63 7.46 8.31 16.72 17.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-95",
    points: "16.56 17.72 16.4 17.88 7.46 8.94 7.46 8.63 16.56 17.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-86",
    points: "16.4 17.88 16.24 18.04 7.46 9.26 7.46 8.94 16.4 17.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-103",
    points: "16.24 18.04 16.09 18.2 7.46 9.57 7.46 9.26 16.24 18.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-122",
    points: "16.09 18.2 15.93 18.35 7.46 9.89 7.46 9.57 16.09 18.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-129",
    points: "15.93 18.35 15.77 18.51 7.46 10.21 7.46 9.89 15.93 18.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-173",
    points: "15.77 18.51 15.61 18.67 7.46 10.52 7.46 10.21 15.77 18.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-173",
    points: "15.61 18.67 15.37 18.91 7.46 11 7.46 10.52 15.61 18.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-120",
    points: "15.37 18.91 15.13 19.15 7.46 11.48 7.46 11 15.37 18.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "15.13 19.15 14.9 19.39 7.46 11.95 7.46 11.48 15.13 19.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "14.9 19.39 14.66 19.63 7.46 12.43 7.46 11.95 14.9 19.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "14.66 19.63 14.42 19.86 7.46 12.91 7.46 12.43 14.66 19.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-82",
    points: "14.42 19.86 14.18 20.1 7.46 13.39 7.46 12.91 14.42 19.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-58",
    points: "14.18 20.1 13.94 20.34 7.46 13.87 7.46 13.39 14.18 20.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-162",
    points: "13.94 20.34 13.7 20.58 7.46 14.34 7.46 13.87 13.94 20.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-128",
    points: "13.7 20.58 13.46 20.82 7.46 14.82 7.46 14.34 13.7 20.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-140",
    points: "13.46 20.82 13.22 21.06 7.46 15.3 7.46 14.82 13.46 20.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-161",
    points: "13.22 21.06 12.98 21.3 7.46 15.78 7.46 15.3 13.22 21.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-134",
    points: "12.98 21.3 12.74 21.54 7.46 16.26 7.46 15.78 12.98 21.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-121",
    points: "12.74 21.54 12.51 21.78 7.46 16.73 7.46 16.26 12.74 21.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-121",
    points: "12.51 21.78 11.75 22.53 7.46 18.24 7.46 16.73 12.51 21.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-156",
    points: "11.75 22.53 11 23.28 7.46 19.74 7.46 18.24 11.75 22.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "11 23.28 10.25 24.03 7.46 21.24 7.46 19.74 11 23.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "10.25 24.03 10.02 24.26 8.98 24.26 7.46 22.75 7.46 21.24 10.25 24.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "7.46 22.75 8.98 24.26 7.46 24.26 7.46 22.75"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-76"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 24.83,
    y: 11.79,
    width: 0.1,
    height: 6.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 24.62,
    y: 11.79,
    width: 0.21,
    height: 6.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-127",
    x: 24.41,
    y: 11.79,
    width: 0.21,
    height: 6.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: 24.2,
    y: 11.79,
    width: 0.21,
    height: 6.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 23.99,
    y: 11.79,
    width: 0.21,
    height: 6.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 23.78,
    y: 11.79,
    width: 0.21,
    height: 6.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 23.57,
    y: 11.79,
    width: 0.21,
    height: 6.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 23.36,
    y: 11.79,
    width: 0.21,
    height: 6.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 23.14,
    y: 11.79,
    width: 0.21,
    height: 6.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 22.93,
    y: 11.79,
    width: 0.21,
    height: 6.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-118",
    x: 22.72,
    y: 11.79,
    width: 0.21,
    height: 6.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 22.51,
    y: 11.79,
    width: 0.21,
    height: 6.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 22.3,
    y: 11.79,
    width: 0.21,
    height: 6.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-81",
    x: 22.09,
    y: 11.79,
    width: 0.21,
    height: 6.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 21.88,
    y: 11.79,
    width: 0.21,
    height: 6.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 21.67,
    y: 11.79,
    width: 0.21,
    height: 6.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 21.46,
    y: 11.79,
    width: 0.21,
    height: 6.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 21.24,
    y: 11.79,
    width: 0.21,
    height: 6.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 21.03,
    y: 11.79,
    width: 0.21,
    height: 6.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 20.82,
    y: 11.79,
    width: 0.21,
    height: 6.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-149",
    x: 20.61,
    y: 11.79,
    width: 0.21,
    height: 6.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 20.4,
    y: 11.79,
    width: 0.21,
    height: 6.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 20.19,
    y: 11.79,
    width: 0.21,
    height: 6.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 19.98,
    y: 11.79,
    width: 0.21,
    height: 6.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 19.77,
    y: 11.79,
    width: 0.21,
    height: 6.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: 19.56,
    y: 11.79,
    width: 0.21,
    height: 6.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-151",
    x: 19.34,
    y: 11.79,
    width: 0.21,
    height: 6.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 19.13,
    y: 11.79,
    width: 0.21,
    height: 6.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-164",
    x: 18.92,
    y: 11.79,
    width: 0.21,
    height: 6.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 18.71,
    y: 11.79,
    width: 0.21,
    height: 6.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 18.5,
    y: 11.79,
    width: 0.21,
    height: 6.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-145",
    x: 18.29,
    y: 11.79,
    width: 0.21,
    height: 6.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 18.08,
    y: 11.79,
    width: 0.21,
    height: 6.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 17.87,
    y: 11.79,
    width: 0.21,
    height: 6.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 17.59,
    y: 11.79,
    width: 0.28,
    height: 6.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 17.32,
    y: 11.79,
    width: 0.28,
    height: 6.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 17.09,
    y: 11.79,
    width: 0.22,
    height: 6.34
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-78"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-135",
    points: "20.23 18.34 16.82 14.93 20.23 14.93 20.23 18.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-135",
    points: "20.23 18.91 16.25 14.93 16.82 14.93 20.23 18.34 20.23 18.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "20.23 19.47 15.69 14.93 16.25 14.93 20.23 18.91 20.23 19.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "20.23 20.04 15.12 14.93 15.69 14.93 20.23 19.47 20.23 20.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-154",
    points: "20.23 20.17 20.01 20.39 14.77 15.14 14.98 14.93 15.12 14.93 20.23 20.04 20.23 20.17"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-172",
    x: 17.05,
    y: 14.2,
    width: 0.4,
    height: 7.42,
    transform: "translate(-7.61 17.44) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-126",
    x: 16.77,
    y: 14.48,
    width: 0.4,
    height: 7.42,
    transform: "translate(-7.89 17.32) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-148",
    x: 16.48,
    y: 14.76,
    width: 0.4,
    height: 7.42,
    transform: "translate(-8.18 17.21) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 16.2,
    y: 15.05,
    width: 0.4,
    height: 7.42,
    transform: "translate(-8.46 17.09) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-111",
    x: 15.92,
    y: 15.33,
    width: 0.4,
    height: 7.42,
    transform: "translate(-8.74 16.97) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 15.63,
    y: 15.61,
    width: 0.4,
    height: 7.42,
    transform: "translate(-9.03 16.86) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 15.35,
    y: 15.9,
    width: 0.4,
    height: 7.42,
    transform: "translate(-9.31 16.74) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 15.07,
    y: 16.18,
    width: 0.4,
    height: 7.42,
    transform: "translate(-9.59 16.62) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-160",
    x: 14.78,
    y: 16.46,
    width: 0.4,
    height: 7.42,
    transform: "translate(-9.88 16.5) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-131",
    x: 14.5,
    y: 16.75,
    width: 0.4,
    height: 7.42,
    transform: "translate(-10.16 16.39) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 14.22,
    y: 17.03,
    width: 0.4,
    height: 7.42,
    transform: "translate(-10.44 16.27) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-98",
    x: 13.93,
    y: 17.31,
    width: 0.4,
    height: 7.42,
    transform: "translate(-10.72 16.15) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-159",
    x: 13.65,
    y: 17.6,
    width: 0.4,
    height: 7.42,
    transform: "translate(-11.01 16.03) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 13.37,
    y: 17.88,
    width: 0.4,
    height: 7.42,
    transform: "translate(-11.29 15.92) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-143",
    points: "16.05 24.35 15.77 24.63 15.76 24.63 10.52 19.39 10.8 19.11 16.05 24.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-153",
    points: "15.2 24.63 10.24 19.67 10.52 19.39 15.76 24.63 15.2 24.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "14.63 24.63 9.95 19.96 10.24 19.67 15.2 24.63 14.63 24.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "14.06 24.63 9.67 20.24 9.95 19.96 14.63 24.63 14.06 24.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "13.5 24.63 9.39 20.52 9.67 20.24 14.06 24.63 13.5 24.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-105",
    points: "12.93 24.63 9.1 20.81 9.39 20.52 13.5 24.63 12.93 24.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-45",
    points: "12.37 24.63 8.82 21.09 9.1 20.81 12.93 24.63 12.37 24.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "11.8 24.63 8.54 21.37 8.82 21.09 12.37 24.63 11.8 24.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-56",
    points: "11.23 24.63 8.26 21.65 8.54 21.37 11.8 24.63 11.23 24.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "10.67 24.63 7.97 21.94 8.26 21.65 11.23 24.63 10.67 24.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "10.1 24.63 7.76 22.29 7.76 22.15 7.97 21.94 10.67 24.63 10.1 24.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-150",
    points: "9.53 24.63 7.76 22.86 7.76 22.29 10.1 24.63 9.53 24.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "8.97 24.63 7.76 23.43 7.76 22.86 9.53 24.63 8.97 24.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-101",
    points: "8.4 24.63 7.76 23.99 7.76 23.43 8.97 24.63 8.4 24.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-60",
    points: "7.84 24.63 7.76 24.56 7.76 23.99 8.4 24.63 7.84 24.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "7.76 24.56 7.84 24.63 7.76 24.63 7.76 24.56"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-77"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-139",
    points: "7.78 5.22 7.76 5.24 7.76 5.22 7.78 5.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-155",
    points: "7.99 5.22 7.76 5.45 7.76 5.24 7.78 5.22 7.99 5.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-174",
    points: "8.19 5.22 7.76 5.65 7.76 5.45 7.99 5.22 8.19 5.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "8.4 5.22 7.76 5.86 7.76 5.65 8.19 5.22 8.4 5.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-114",
    points: "8.6 5.22 7.76 6.06 7.76 5.86 8.4 5.22 8.6 5.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "8.81 5.22 7.76 6.27 7.76 6.06 8.6 5.22 8.81 5.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "9.01 5.22 7.76 6.48 7.76 6.27 8.81 5.22 9.01 5.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-54",
    points: "9.22 5.22 7.76 6.68 7.76 6.48 9.01 5.22 9.22 5.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "9.42 5.22 7.76 6.89 7.76 6.68 9.22 5.22 9.42 5.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-175",
    points: "9.63 5.22 7.76 7.09 7.76 6.89 9.42 5.22 9.63 5.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "9.83 5.22 7.76 7.3 7.76 7.09 9.63 5.22 9.83 5.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "10.04 5.22 7.76 7.5 7.76 7.3 9.83 5.22 10.04 5.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-107",
    points: "10.25 5.22 7.76 7.71 7.76 7.5 10.04 5.22 10.25 5.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-110",
    points: "10.45 5.22 7.83 7.85 7.76 7.78 7.76 7.71 10.25 5.22 10.45 5.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-115",
    points: "10.66 5.22 7.93 7.95 7.83 7.85 10.45 5.22 10.66 5.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-133",
    points: "10.86 5.22 8.03 8.05 7.93 7.95 10.66 5.22 10.86 5.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-88",
    points: "11.07 5.22 8.14 8.16 8.03 8.05 10.86 5.22 11.07 5.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "11.27 5.22 8.24 8.26 8.14 8.16 11.07 5.22 11.27 5.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-141",
    points: "11.48 5.22 8.34 8.36 8.24 8.26 11.27 5.22 11.48 5.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "11.68 5.22 8.44 8.47 8.34 8.36 11.48 5.22 11.68 5.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-144",
    points: "11.89 5.22 8.55 8.57 8.44 8.47 11.68 5.22 11.89 5.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "12.09 5.22 8.65 8.67 8.55 8.57 11.89 5.22 12.09 5.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "12.3 5.22 8.75 8.77 8.65 8.67 12.09 5.22 12.3 5.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-99",
    points: "12.51 5.22 8.85 8.88 8.75 8.77 12.3 5.22 12.51 5.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-99",
    points: "12.84 5.22 9.02 9.04 8.85 8.88 12.51 5.22 12.84 5.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-55",
    points: "13.18 5.22 9.19 9.21 9.02 9.04 12.84 5.22 13.18 5.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "13.51 5.22 9.36 9.38 9.19 9.21 13.18 5.22 13.51 5.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "13.85 5.22 9.53 9.55 9.36 9.38 13.51 5.22 13.85 5.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-53",
    points: "14.18 5.22 9.69 9.71 9.53 9.55 13.85 5.22 14.18 5.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "14.52 5.22 9.86 9.88 9.69 9.71 14.18 5.22 14.52 5.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-96",
    points: "14.85 5.22 10.03 10.05 9.86 9.88 14.52 5.22 14.85 5.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "15.19 5.22 10.2 10.22 10.03 10.05 14.85 5.22 15.19 5.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "15.52 5.22 10.36 10.39 10.2 10.22 15.19 5.22 15.52 5.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "15.77 5.22 20.23 9.68 20.23 14.93 14.91 14.93 10.36 10.39 15.52 5.22 15.77 5.22"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.15,17.99l-10.82,6.12c-.6.37-1.12.3-1.49,0l-.07.07.07.07c.37.3.9.37,1.49,0l10.82-6.27Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.76,24.11c-.22-.22-.3-.6-.3-1.04v.07c0,.45.15.82.37,1.04v-.07h-.07ZM23.89,15.9l-3.73,2.09.07.07,3.66-2.09c.52-.3.75-.67.75-1.04,0,.37-.3.67-.75.97Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M9.33,5.67l14.56,8.29c.45.3.75.6.75.97,0-.37-.22-.75-.75-1.04L9.33,5.6c-1.04-.6-1.87-.15-1.87,1.04v.07c0-1.12.82-1.64,1.87-1.04Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/GooglePlay.7a9b62bb2d4fa12b9f57d1520c4f702d.svg";
export { ForwardRef as ReactComponent };